export default {"src":"/_next/static/media/filterIcon.21acb32a.svg","height":24,"width":24};